import { CoreApi, ImageType, Product, ProductType } from '@inter-ikea-storageone/range';
import { getLastProductImageOfType, getQPPImage } from 'products/utils';
import { ProductListConfig } from 'rangeConfig/@types';
import autoFillSlidingDoors from 'rangeConfig/platsa/behaviors/autoFillSlidingDoors';
import removeAllDrawersAndHingedDoorsInScene from 'rangeConfig/platsa/behaviors/removeAllDrawersAndHingedDoorsInScene';
import removeAllSlidingDoorsInScene from 'rangeConfig/platsa/behaviors/removeAllSlidingDoorsInScene';
import {
  matchDoorOpeningFunction,
  matchFrontSizeToFramesInScene,
  matchFrontTypeToFramesInScene
} from 'rangeConfig/platsa/filters/mainMenuProductFilters';
import changePlatsaFrontBehavior from '../../behaviors/changeFront';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import addFrontStyleToFrameBehavior from 'rangeConfig/platsa/behaviors/addFrontStyleToFrame';
import {
  matchHeightToFramesInScene,
  matchWidthToFramesInScene
} from 'rangeConfig/shared/filters/mainMenuProductFilters';
import {} from 'rangeConfig/shared/rules/hideMenuRules';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import { sortNestedClusterProductsByHeight } from 'rangeConfig/shared/sorting/sort';
import { getPlatsaSlidingDoorsNotPossibleErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { store } from 'ducks';
import {
  hidePlatsaAddingFrontToOpenFrameErrorMessage,
  hidePlatsaSlidingDoorsNotPossibleErrorMessage
} from 'rangeConfig/platsa/rules/hideMenuRules';

export const frontsProductListConfig: ProductListConfig = {
  cluster: ['name', 'design'],
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  productCardMainImage: getQPPImage,
  productCardHoverImage: getQPPImage,
  behaviors: {
    productClicked: [showDoors, removeAllSlidingDoorsInScene, changePlatsaFrontBehavior],
    productDropped: [showDoors, addFrontStyleToFrameBehavior]
  },
  productFilters: [
    matchFrontTypeToFramesInScene,
    matchFrontSizeToFramesInScene,
    matchDoorOpeningFunction
  ],
  sortOrder: [],
  sortClusteredProducts: sortNestedClusterProductsByHeight,
  categories: [
    {
      id: 'fronts',
      categoryTitle: '',
      products: [
        { path: 'type', value: ProductType.PLATSA_HINGE_DOOR_ASM },
        { path: 'type', value: ProductType.PLATSA_DRAWER_ASM },
        { path: 'type', value: ProductType.PLATSA_SC_HINGE_DOOR_ASM }
      ],
      noneOption: {
        title: 'storageone.productListNoDoorsOrDrawersOptionTitle',
        behaviors: { removeProducts: [removeAllDrawersAndHingedDoorsInScene] },
        selected: noProductsWithTypesInScene([
          ProductType.PLATSA_HINGE_DOOR_ASM,
          ProductType.PLATSA_DRAWER_ASM,
          ProductType.PLATSA_SC_HINGE_DOOR_ASM
        ])
      }
    }
  ]
};

export const slidingDoorsProductListConfig: ProductListConfig = {
  cluster: ['design'],
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  productCardMainImage: getQPPImage,
  productCardHoverImage: (product: Product) => getLastProductImageOfType(product, ImageType.FPP),
  behaviors: {
    productClicked: [showDoors, autoFillSlidingDoors],
    productDropped: [showDoors, autoFillSlidingDoors]
  },
  productFilters: [matchWidthToFramesInScene, matchHeightToFramesInScene],
  sortOrder: [],
  categories: [
    {
      id: 'sliding-doors',
      categoryTitle: 'storageone.doorCategoryTitleSlidingDoors',
      widgets: [
        {
          component: withErrorMessage(getPlatsaSlidingDoorsNotPossibleErrorMessage)(
            ErrorMessageInline
          ),
          hidden: (coreApi: CoreApi) =>
            hidePlatsaSlidingDoorsNotPossibleErrorMessage(
              coreApi,
              store.getState().products.inMarket
            ) || !hidePlatsaAddingFrontToOpenFrameErrorMessage(coreApi)
        }
      ],
      products: [{ path: 'type', value: ProductType.PLATSA_SLIDING_DOOR_ASM }],
      noneOption: {
        title: 'storageone.productListNoSlidingDoorsOptionTitle',
        behaviors: { removeProducts: [removeAllSlidingDoorsInScene] },
        selected: noProductsWithTypesInScene([ProductType.PLATSA_SLIDING_DOOR_ASM])
      }
    }
  ]
};
